import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AsaasService {

  constructor (private _http: HttpClient) { }

  async asaasPaymentDev (payload: any): Promise<any> {
    const URL_CREATE_PAYMENT_DEV = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasPaymentDev';

    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response: any = await this._http.post(URL_CREATE_PAYMENT_DEV, payload, {headers}).toPromise();
      return response;
    } catch (error) {
      console.log('Erro em asaasAction status:', error.status);
      console.log('Erro em asaasAction message:', error.message);
      return error.status;
    }
  }

  async asaasPayment (payload: any): Promise<any> {
    const URL_CREATE_PAYMENT = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasPayment';

    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response: any = await this._http.post(URL_CREATE_PAYMENT, payload, {headers}).toPromise();
      return response;
    } catch (error) {
      console.log('Erro em asaasAction status:', error.status);
      console.log('Erro em asaasAction message:', error.message);
      return error.status;
    }
  }

  async asaasAction (payload: any): Promise<any> {
    const ASAAS_URL = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasActionDev';

    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response: any = await this._http.post(ASAAS_URL, payload, {headers}).toPromise();
      return response;
    } catch (error) {
      console.log('Erro em asaasActionk:', error.status);
      return error.status;
    }
  }

}

